import { SerializedStyles } from '@emotion/react';
import React, { ReactNode } from 'react';

import type { CreateIconComponentProps } from '../SvgIcons/CreateIconComponent';

import {
  TopicLink,
  HedWrapper,
  TopicsList,
  NoWrapLink,
  TopicTilesWrapper,
  StyledH3,
} from './TopicTiles.styles';

export type TopicTilesProps = {
  className?: string;
  title: string;
  topics: {
    /** @deprecated use iconComponent */
    icon?: React.FC<CreateIconComponentProps>;
    iconComponent?: ReactNode;
    name: string;
    href: string;
    /** Include any styles that could override a tile, including hiding for specified media query */
    tileCssOverrides?: SerializedStyles;
  }[];
  cta?: {
    text: string;
    href: string;
  };
};

const TopicTiles: React.FC<TopicTilesProps> = ({
  className,
  title,
  cta,
  topics,
}: TopicTilesProps): JSX.Element => {
  return (
    <TopicTilesWrapper className={className}>
      <HedWrapper>
        <StyledH3>{title}</StyledH3>

        {cta && (
          <NoWrapLink arrow inline href={cta.href}>
            {cta.text}
          </NoWrapLink>
        )}
      </HedWrapper>
      <TopicsList>
        {topics.map(({ name, href, icon: Icon, iconComponent, tileCssOverrides }, index) => (
          <li key={`topic-link-${index}`} css={tileCssOverrides || undefined}>
            <TopicLink href={href} hasIcon={Boolean(Icon || iconComponent)}>
              {Icon && <Icon width={24} height={24} />}
              {iconComponent || null}
              {name}
            </TopicLink>
          </li>
        ))}
      </TopicsList>
    </TopicTilesWrapper>
  );
};

export default TopicTiles;
